
export const ConnectionAlreadyRequested = "You have already requested to connect with this user";
export const UserAlreadyConnected = "You're already connected";
export const ConnectionRejected ="Your connection request has been rejected";
export const ConnectionRequested ="Connection request sent successfully";
export const ConnectionBlocked ="Your connection request has been blocked";
export const ConnectionDeleted ="Your connection request has been deleted";
export const OnSettingEmailAlertsError ="You are not logged in. Please login to set email alerts";
export const ServerError_Message = "Something went wrong. Please try again or contact at info@apply4u.co.uk";
export const ValidCredentialsError_Message ="Please provide valid credentials";
export const InvalidLogin_Message = "Email or password invalid"
export const NotLoggedIn_Message = "You are not logged in!";
export const AlreadyWishListed_Message = "Shortlist already exists";
export const AlreadyShortListed_Message = "Shortlist already exists";
export const SavedSuccessfully_Message = "Saved Successfully";
export const ChangesSavedSuccessfully_Message = "Changes Saved Successfully";
export const UpdatedSuccessfully_Message = "Updated Successfully";
export const DeletedSuccessfully_Message = "Deleted Successfully";
export const PostedSuccessfully_Message = "Posted Successfully";
export const JobExpiredSuccessfully_Message = "Job Expired Successfully";
export const JobPostedAgainSuccessfully_Message = "Job reposted successfully";
export const FeildsRequired_Message = "All fields marked with an asterisk (*) are required";
export const PhoneNoRequired_Message = "Phone number is required";
export const AddressRequired_Message = "Address is required.";
export const EmailIsRequired_Message = "Email Address is required";
export const DescriptionRequired_Message = "Description is required.";
export const InvalidFileFormate_Message = "Selected file format is not supported.";
export const UploadYourCV_Message = "Please Upload your CV.";
export const DateRequired_Message = "Please provide the valid date for the job advertisement.";